import { isCardFieldValueEqual, type CardFieldValueEqualContext } from '@zaoblako/web/shared/components/card-layout/universal-card-v2/card-field-value-equal.util';

import { cloneDeep, get, set } from 'lodash';

export class CardEntityPatchBaseline<TEntity extends object> {
  private baseline: TEntity | null = null;

  public sync = (entity: TEntity | null): void => {
    this.baseline = entity ? cloneDeep(entity) : null;
  };

  public fieldValue = (fieldKey: string): unknown =>
    this.baseline ? get(this.baseline, fieldKey) : undefined;

  public isFieldUnchanged = (fieldKey: string, nextValue: unknown, context?: CardFieldValueEqualContext): boolean =>
    isCardFieldValueEqual(this.fieldValue(fieldKey), nextValue, { ...context, fieldKey });

  public commitField = (fieldKey: string, value: unknown): void => {
    if (!this.baseline) {
      return;
    }
    set(this.baseline as object, fieldKey, cloneDeep(value));
  };
}
